<template>
  <box class="metrix-box-wrap">
    <metrixBox>
      <template v-for="field in orderedSummaryStat">
        <metrixItem :itemTitle="field.name"
                    :itemValue="field.value"
                    :prevValue="field.prevValue"
                    :summaryStatQueriesCount="summaryStatQueriesCount"
                    :key="field.key"
                    v-if="field.checked"
                    valueSaldo="up"></metrixItem>
      </template>


    </metrixBox>
    
    <actionOptions :sections="['Performance', 'Metrics']"
                   :options="summaryMetrics"
                   :showSelectAll="true"
                   @change="onMetricsChanged($event)"
                   class="alt"/>
  </box>
</template>

<script>
import userCanSeeMixin from '@/lib/userCanSee';
import { currencyFormatter, integerFormatter, percentFormatter } from '@/lib/numberFormatters';
import { calculatePrevPeriod } from '@/lib/periodToDates';
import moment from 'moment';
import { dayFormat } from '@/lib/periodToDates';
import _ from 'lodash';

export default {
  name: 'summary-statistic',

  props: {
    range: {
      type: Array,
    },
    users: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  mixins: [userCanSeeMixin],

  data: function () {
    return {
      fromDate: this.range[0],
      toDate: this.range[1],
      summaryStatQueriesCount: 0,
      summaryStat: {},
      prevSummaryStat: {},
      defaultSelectedMetrics: ['bids', 'wins', 'impressions', 'viewabilityMeasurable', 'ctr', 'ecpm', 'ecpc', 'ecpc', 'dspSpend', 'winrate',],
      selectedMetrics: [],
      metricSection: {
        bids: 'Performance',
        wins: 'Performance',
        impressions: 'Performance',
        viewabilityMeasurable: 'Performance',
        clicks: 'Performance',
        conversions: 'Performance',
        dspSpend: 'Performance',
        reach: 'Performance',
        ecpm: 'Metrics',
        ecpc: 'Metrics',
        ecpa: 'Metrics',
        ctr: 'Metrics',
        winrate: 'Metrics',
      },
      summaryMetrics: {
        Performance: [{
          name: this.$t('Bids'),
          checked: true,
          disabled: false,
          checkID: 'bids',
        }, {
          name: this.$t('Wins'),
          checked: true,
          disabled: false,
          checkID: 'wins',
        }, {
          name: this.$t('Impressions'),
          checked: true,
          disabled: false,
          checkID: 'impressions',
        }, {
          name: this.$t('Viewability'),
          checked: true,
          disabled: false,
          checkID: 'viewabilityMeasurable',
        }, {
          name: this.$t('Clicks'),
          checked: true,
          disabled: false,
          checkID: 'clicks',
        }, {
          name: this.$t('Conversions'),
          checked: true,
          disabled: false,
          checkID: 'conversions',
        }, {
          name: this.$t('Reach'),
          checked: true,
          disabled: false,
          checkID: 'reach',
        }, {
          name: this.$t('Spend'),
          checked: true,
          disabled: false,
          checkID: 'dspSpend',
        }, // {
          //     name: "Revenue",
          //     checked: true,
          //     disabled: false,
          //     checkID: "sspPrice",
          // },

        ],
        Metrics: [{
          name: this.$t('eCPM'),
          checked: true,
          disabled: false,
          checkID: 'ecpm',
        }, {
          name: 'eCPC',
          checked: true,
          disabled: false,
          checkID: 'ecpc',
        }, // {
          //     name: "eCPA",
          //     checked: true,
          //     disabled: false,
          //     checkID: "ecpa",
          // },
          // {
          //     name: "CTR",
          //     checked: true,
          //     disabled: false,
          //     checkID: "ctr",
          // },
          {
            name: this.$t('WinRate'),
            checked: true,
            disabled: false,
            checkID: 'winrate',
          },]
      },
      isLoading: true,
      valueFormaters: {
        bids: integerFormatter,
        clicks: integerFormatter,
        conversions: integerFormatter,
        impressions: integerFormatter,
        reach: integerFormatter,
        wins: integerFormatter,
        ctr: percentFormatter,
        winrate: percentFormatter,
        dspSpend: currencyFormatter, // sspPrice: currencyFormatter,
        ecpa: currencyFormatter,
        ecpc: currencyFormatter,
        ecpm: currencyFormatter,
        viewabilityMeasurable: percentFormatter,
      },
    };
  },

  computed: {
    fieldName: {
      get () {
        let fields = {};
        this.summaryMetrics.Performance.map(i => {
          fields[i.checkID] = i.name;
        });
        this.summaryMetrics.Metrics.map(i => {
          fields[i.checkID] = i.name;
        });
        return fields;
      },
    },
    orderedSummaryStat() {
      return this.summaryMetrics.Performance
        .concat(this.summaryMetrics.Metrics)
        .filter(item => this.summaryStat[item.checkID] !== undefined)
        .map(item => ({
          key: item.checkID,
          name: item.name,
          value: this.valueFormaters[item.checkID](this.summaryStat[item.checkID]),
          prevValue: this.valueFormaters[item.checkID](this.prevSummaryStat[item.checkID]),
          checked: this.isMetricActive(item.checkID)
        }));
    }
  },

  watch: {
    selectedMetrics () {
      // ['Metrics', 'Performance'].map(sec => {
      //     this.summaryMetrics[sec].map( m => {
      //         if(!m.checked) {
      //             m.disabled = selected.length > 7;
      //         }
      //     })
      // });

      this.getSummaryStat();
    },
    range () {
      this.fromDate = this.range[0];
      this.toDate = this.range[1];
      this.getSummaryStat();
    },
    users: {
      deep: true,
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          this.getSummaryStat();
        }
      }
    }
  },

  created () {
    this.checkCanSeeAccess();

    if (!localStorage.getItem('summaryStatMetrics')) {
      this.selectedMetrics = this.defaultSelectedMetrics;
    } else {
      this.changeOldNameMetrics();

      this.selectedMetrics = JSON.parse(localStorage.getItem('summaryStatMetrics'));

    }

    let perfomance = this.summaryMetrics.Performance.filter(i => {
      if (i.checkID == 'sspSpend' && !this.$auth.hasRole('admin')) {
        return false;
      }

      return true;
    });

    this.summaryMetrics.Performance = perfomance;

    this.summaryMetrics.Performance.map(i => {
      i.checked = this.selectedMetrics.includes(i.checkID);
    });
    this.summaryMetrics.Metrics.map(i => {
      i.checked = this.selectedMetrics.includes(i.checkID);
    });
    this.fromDate = this.range[0];
    this.toDate = this.range[1];
    // this.getSummaryStat(); // Called by watchers
  },

  methods: {

    //for new ClickHouse (because the old columns are now named differently)
    changeOldNameMetrics () {
      let newElements = JSON.parse(localStorage.getItem('summaryStatMetrics')).map(function (item) {
        switch (item) {
          case 'bidResponse':
            item = 'bids';
            break;
          case 'win':
            item = 'wins';
            break;
          case 'impression':
            item = 'impressions';
            break;
          case 'click':
            item = 'clicks';
            break;
          case 'conversion':
            item = 'conversions';
            break;
          case 'dspPrice':
            item = 'dspSpend';
            break;
        }

        return item;

      });
      localStorage.setItem('summaryStatMetrics', JSON.stringify(newElements));
    },

    checkCanSeeAccess () {
      if (this.$auth.hasRole('admin') ){
        return;
      }
      if (!this.userCanSeeClicks) {
        this.summaryMetrics.Performance = this.summaryMetrics.Performance.filter(item => !['clicks', 'conversions', 'ctr', 'ecpa'].includes(item.checkID));
        this.summaryMetrics.Metrics = this.summaryMetrics.Metrics.filter(item => !['ecpc'].includes(item.checkID));
      }
      if (this.$auth.hasRole('advert')) {
        this.summaryMetrics.Performance = this.summaryMetrics.Performance.filter(item => item.checkID !== 'viewability');
      }
      
      if (this.$auth.hasPermission('cant-see-prices')) {
        this.summaryMetrics.Performance = this.summaryMetrics.Performance.filter(item => ![ 'dspSpend'].includes(item.checkID));
        this.summaryMetrics.Metrics = this.summaryMetrics.Metrics.filter(item => !['ecpm','ecpc'].includes(item.checkID));

      }
      
      if (this.$auth.user().email.includes('@electica.io') || [18304, 19261, 19621].includes(this.$auth.user().id)) {
        this.summaryMetrics.Performance = this.summaryMetrics.Performance.filter(item => item.checkID !== 'viewabilityMeasurable');
      }
      
    },

    getDefaultRange () {
      return [moment(), moment()];
    },

    getSummaryStat () {
      if (this.selectedMetrics.length === 0) {
        this.summaryStatQueriesCount = 0;
        this.summaryStat = [];
        this.prevSummaryStat = [];

        return;
      }

      let dateFrom = this.fromDate.format(dayFormat);
      let dateTo = this.toDate.format(dayFormat);

      const res = calculatePrevPeriod(this.fromDate, this.toDate);

      let prevDateFrom = res[0].format('YYYY-MM-DD');
      let prevDateTo = res[1].format('YYYY-MM-DD');

      const agregatedFields = this.selectedMetrics;

      this.summaryStatQueriesCount = 0;

      this.isLoading = true;
      let filter = {};
      if (this.$auth.hasRole('agency')) {
        filter = {
          'advertiserId': this.users.map(a => a['value']),
        };
      }

      // if ( data['filter'] = {
      //   'campaignId': this.chartSelectedCampaign.id,
      // };)
      this.$axios.post('/statistic', {
        groupBy: [],
        from: dateFrom,
        to: dateTo,
        filter: filter,
        agregatedFields
      })
          .then(resp => {
            this.summaryStat = resp.data.totals;
            
            this.$axios.post('/statistic', {
              groupBy: [],
              from: prevDateFrom,
              to: prevDateTo,
              agregatedFields
            })
                .then(resp => {
                  this.summaryStatQueriesCount += 1;
                  this.prevSummaryStat = resp.data.totals;
                  this.isLoading = false;
                })
                .catch(() => {
                  this.summaryStat = {};
                  this.isLoading = false;
                });

          })
          .catch(() => {
            this.summaryStat = {};
            this.isLoading = false;
          });

    },

    isMetricActive: function (field) {
      if (field == 'sspPrice' && !this.$auth.hasRole('admin')) {
        return false;
      }

      let item = this.summaryMetrics[this.metricSection[field]];

      if (!item) {
        return false;
      }

      let summaryMetricsItem = item.find(i => {
        return i.checkID === field;
      });

      if (!summaryMetricsItem) {
        return false;
      }

      return summaryMetricsItem.checked;
    },

    onMetricsChanged: function (event) {
      this.selectedMetrics = event;
      localStorage.setItem('summaryStatMetrics', JSON.stringify(event));
    }
  }
};
</script>

<style lang="scss" scoped>
.ps {
  padding: 0;
}

.metrix-box-wrap {
  width: calc(100vw - 200px);
  position: relative;
}

.options {
  &.alt {
    width: 30px;
    height: 40px;
    position: absolute;
    top: 0px;
    right: 0px;
    padding-top: 0px;
    padding-right: 0px;
    text-align: center;

    .dropdown-trigger {
      width: 20px;
      height: 18px;
      display: inline-block;

      a {
        position: static;

        .icon {
          position: static;

          svg {
            margin-top: 0;
          }
        }
      }

    }
  }

  .icon {
    position: static;

    svg {
      margin-top: 0;
    }
  }
}
</style>
